<template>
  <v-layout>
    <v-card class="card-box">
      <v-card-title class="subheading font-weight-bold justify-center">
        Top Competitors
        <v-icon style="font-size: 18px;" class="ml-1 pointer"
          v-tooltip.top-center="{
            content: searchType === 'domain' ? 'Top websites competing with your domain' : 'Top websites ranking for your keyword in Google',
            trigger: $store.state.metadata.windowWidth > 600 ? 'hover' : 'click'
          }"
        >help_outline</v-icon>
      </v-card-title>
      <!-- <div class="pb-1 text-xs-center">updated: {{ topCompetitorsLastUpdate ? $moment(topCompetitorsLastUpdate).format('DD-MM-YYYY') : '-' }}</div> -->
      <v-divider></v-divider>
      <v-list dense>
        <template>
          <v-data-table
            class="table-competition"
            :headers="headerTopCompetitors"
            :items="topCompetitors.length ? topCompetitors.slice(0, 5) : []"
            :hide-actions="true"
            item-key="name"
          >
            <template v-slot:items="props" v-if="topCompetitors && topCompetitors.length > 0">
              <tr>
                <td>{{ props.item.domain ? props.item.domain : '-' }}</td>
                <td v-if="searchType === 'keyword'" class="text-xs-center">
                  <span v-if="props.item.change > 0" class="keyword-change green--text">
                    <v-icon class="green--text">arrow_drop_up</v-icon>
                    <span>{{ props.item.keywords_count }}</span>
                  </span>
                  <span v-else-if="props.item.change < 0" class="keyword-change red--text">
                    <v-icon class="red--text">arrow_drop_down</v-icon>
                    <span>{{ props.item.keywords_count }}</span>
                  </span>
                  <span v-else>-</span>
                </td>
                <td v-if="searchType === 'domain'" class="text-xs-center">
                  <span v-if="props.item.change > 0" class="keyword-change green--text">
                    <v-icon class="green--text">arrow_drop_up</v-icon>
                    <span>+{{ props.item.change }}</span>
                  </span>
                  <span v-else-if="props.item.change < 0" class="keyword-change red--text">
                    <v-icon class="red--text">arrow_drop_down</v-icon>
                    <span>{{ props.item.change }}</span>
                  </span>
                  <span v-else>-</span>
                </td>
                <td v-if="searchType === 'domain'" class="text-xs-center">{{ props.item.common_keywords ? props.item.common_keywords : '-' }}</td>
              </tr>
            </template>
            <template slot="no-data">
              <tr>
                <td class="text-xs-center" colspan="4">
                  <span>No data available</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-list-tile>
          <v-list-tile-content v-if="topCompetitors && topCompetitors.length > 0" :style="{ 'align-items':'center' }">
            <a v-if="$store.state.user.email" @click="viewMoreCompetitorsDialog = true">View more</a>
            <a v-else @click="$router.push({name: 'Login'})">Login to see more</a>
          </v-list-tile-content>
          <!-- <v-list-tile-content class="align-end">protein</v-list-tile-content> -->
        </v-list-tile>
      </v-list>
    </v-card>
    <TopCompetotorsBoxModal v-if="viewMoreCompetitorsDialog" :viewMoreCompetitorsDialog="viewMoreCompetitorsDialog" :topCompetitors="topCompetitors" :searchType="searchType"></TopCompetotorsBoxModal>
  </v-layout>
</template>

<script>
export default {
  name: 'TopCompetotorsBox',
  props: ['topCompetitors', 'searchType'],
  data () {
    return {
      loading: false,
      // testData: {'data': [{'domain': 'www.d.co.il', 'common_keywords': 9, 'change': 0}, {'domain': 'www.drushim.co.il', 'common_keywords': 9, 'change': 1}, {'domain': 'www.youtube.com', 'common_keywords': 8, 'change': 2}, {'domain': 'www.leos.co.il', 'common_keywords': 7, 'change': 1}, {'domain': 'www.facebook.com', 'common_keywords': 7, 'change': 2}], 'last_update': '2020-04-20'},
      viewMoreCompetitorsDialog: false,
      topCompetitorsLastUpdate: '',
      headerTopCompetitors: [
        { text: 'Competitors', value: 'domain', sortable: false },
        { text: 'Number of ranking keywords', value: 'keywords_count', sortable: false, align: 'middle', type: 'keyword' },
        { text: 'Change', value: 'change', sortable: false, align: 'middle', type: 'domain' },
        { text: 'Shared keywords', value: 'common_keywords', sortable: false, align: 'middle', type: 'domain' }
      ]
    }
  },
  mounted () {
    this.$on('viewMoreCompetitorsDialog', (value) => {
      this.viewMoreCompetitorsDialog = value
    })
    this.headerTopCompetitors = this.headerTopCompetitors.filter(item => !item.type || item.type === this.searchType)
    // this.topCompetitors = this.testData.data
  },
  beforeDestroy () {
    this.$off('viewMoreCompetitorsDialog')
  },
  methods: {
    // getLinksBox () {
    //   if (this.isAdmin || this.$store.state.user.permissions.links_box) {
    //     let params = {
    //       top: 5,
    //       engine_id: parseInt(this.$route.params.engineId)
    //     }
    //     this.loading = true
    //     this.$store.dispatch('GET_LINKS_BOX', { projectId: this.projectId, params: params }).then(res => {
    //       this.linksBoxAdditional.lastUpdate = res.last_update
    //       this.linksBoxAdditional.ignoredLinks = res.ignored_links_without_ranking
    //       this.linksBox = res.data
    //       this.loading = false
    //     }, err => {
    //       this.loading = false
    //       console.log('GET_LINKS_BOX error', err)
    //       let errorText = this.$services.getApiError(err)
    //       if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss">
  .card-box {
    min-height: 404px;
    width: 100%;
  }
  .table-competition .v-datatable.v-table thead tr th {
    padding: 0 5px;
  }
  .table-competition .v-datatable.v-table thead tr th:first-child {
    padding-left: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/boxes/TopCompetotorsBox.vue